module.exports = "https://la-static.vkplay.ru/promo/newstart/img/blaster.35707d63.png";